import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface RushState {
  isRefreshBalance: boolean
  isRefreshBackpackValues: boolean
  gemBalance?: number
  backpackValues?: number
  // RushSkinsModal 相关状态
  isOpenRushSkinsModal: boolean
}

const initialState: RushState = {
  isRefreshBalance: false,
  isRefreshBackpackValues: false,
  isOpenRushSkinsModal: false,
}

const rushSlice = createSlice({
  name: 'rush',
  initialState,
  reducers: {
    setIsRefreshBalance: (state, action: PayloadAction<boolean>) => {
      state.isRefreshBalance = action.payload
    },
    setIsRefreshBackpackValues: (state, action: PayloadAction<boolean>) => {
      state.isRefreshBackpackValues = action.payload
    },
    setGemBalance: (state, action: PayloadAction<number>) => {
      state.gemBalance = action.payload
    },
    updateGemBalance: (state, action: PayloadAction<number>) => {
      state.gemBalance = (state.gemBalance ?? 0) + action.payload
    },
    setBackpackValues: (state, action: PayloadAction<number>) => {
      state.backpackValues = action.payload
    },
    setIsOpenRushSkinsModal: (state, action: PayloadAction<boolean>) => {
      state.isOpenRushSkinsModal = action.payload
    },
  },
})
export const {
  setIsRefreshBalance,
  setIsRefreshBackpackValues,
  setGemBalance,
  updateGemBalance,
  setBackpackValues,
  setIsOpenRushSkinsModal,
} = rushSlice.actions
export default rushSlice
